export class BankAcc{
    constructor(
        public title: string,
        public initials: string,
        public lname: string,
        public bank: string,
        public accType: string,
        public branchNo: number,
        public accNo: number,
    ){}
}